var _defs, _polygon, _polygon2, _path, _path2, _path3, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerbumLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 274.8 87.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #056d8d;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "70.9 45.2 88 45.2 88 39 70.9 39 70.9 28 90.8 28 90.8 21.8 63.4 21.8 63.4 64.4 91.3 64.4 91.3 58.1 70.9 58.1 70.9 45.2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "41.1 48.8 30 21.8 21.8 21.8 41.1 65.4 60.3 21.8 52.2 21.8 41.1 48.8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.4,41.5h0c2.1-.4,7.5-1.8,7.5-9.8s-5-9.9-12.8-9.9h-18.5v42.5h21.4c7.5,0,12.6-4.8,12.6-11.5s-3.9-10.7-10.1-11.3ZM140,28h9.8c4.8,0,6.5,1.7,6.5,5.4,0,3.4-2.3,5.4-7,5.4h-9.3v-10.8ZM150.2,58.1h-10.1v-13.2h10.8c4.8,0,7.5,2.3,7.5,6.6s-2.1,6.5-8.2,6.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.1,50.3c0,5.8-4.9,8.9-10.3,8.9s-10.3-3.1-10.3-8.9v-28.5h-7.5v28.8c0,10.4,7.9,15,17.8,15s17.8-4.6,17.8-15v-28.8h-7.5v28.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.3,34.6c0-8.2-4.2-12.8-12.7-12.8h-18.8v42.5h7.5v-17.7s9.2,0,9.8,0l7.3,17.7h8.2l-8.3-18.8c4.5-1.4,7.1-5.2,7.1-11ZM103.3,40.2v-11.7h9.5c3.8,0,6.6,2.1,6.6,6s-2.7,5.8-8,5.8h-8.2Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "243.1 21.8 243 21.8 231.9 48.8 220.8 21.8 210.3 21.8 210.3 64.4 217.8 64.4 217.8 33.4 231.9 65.4 245.5 34.7 245.5 64.4 253 64.4 253 21.8 243.1 21.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerbumLogo);
export default __webpack_public_path__ + "static/media/verbum-logo.5df211a096012fe4fe5bb7e3031571c7.svg";
export { ForwardRef as ReactComponent };